var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190.78 190.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        opacity: .16;\n      }\n\n      .cls-2, .cls-3 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #00ae8e;\n      }\n\n      .cls-3 {\n        opacity: .09;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.78,28.2V162.6c0,15.57-12.62,28.19-28.19,28.19H28.19c-15.57,0-28.19-12.62-28.19-28.19V28.2C0,12.63,12.62,.01,28.19,.01H162.59c15.57,0,28.19,12.61,28.19,28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.92,66.23c0,56.79-46.04,102.84-102.83,102.84-23.78,0-45.67-8.07-63.09-21.63V28.2C0,12.63,12.62,.01,28.19,.01h113.56c15.09,17.88,24.17,41,24.17,66.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.17,31.35c0,37.54-30.42,67.96-67.96,67.96-10.06,0-19.61-2.18-28.21-6.1V28.19C0,12.62,12.62,0,28.19,0h60.34c4.88,9.38,7.64,20.04,7.64,31.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.59,135.5l-6.57,20.37h-24.1L84.92,40.57h23.37l46,115.3h-24.83l-32.86-89.74-14.6,37.24-9.49,25.56-2.92,6.57Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.43b19933d02176e45235567ab838d29b.svg";
export { ForwardRef as ReactComponent };